import {Form, Input} from "antd"
import React from "react"
import styled from "styled-components"
import magnifyingGlassSVG from "../../../images/magnifying-glass.svg"

const SearchField = React.memo((props) => {
  const [isFocused, updateIsFocused] = React.useState(false)

  return (
    <Form>
      <OuterDiv isFocused={isFocused}>
        <IconDiv>
          <img src={magnifyingGlassSVG} alt="Search" />
        </IconDiv>
        <Form.Item name="search">
          <FieldInput
            // onBlur={() => updateIsFocused(false)}
            onFocus={() => updateIsFocused(true)}
            placeholder="Search by assignee or company"
          />
        </Form.Item>
        <MenuOuterDiv isFocused={isFocused}>
          <MenuInnerDiv>
            <div>
              Calculation type: <strong>Assignment</strong>
            </div>
            <div>
              Company name: <strong>Hastings</strong>
            </div>
          </MenuInnerDiv>
        </MenuOuterDiv>
      </OuterDiv>
    </Form>
  )
})

const IconDiv = styled.div`
  height: 100%;
  left: 0;
  opacity: 0.5;
  pointer-events: none;
  position: absolute;
  top: 0;
  z-index: 1;
  img {
    height: ${(props) => props.theme.searchInputHeight * 0.4}px;
    margin: ${(props) => props.theme.searchInputHeight * 0.3}px;
  }
`

const FieldInput = styled(Input)`
  background-color: transparent;
  border: 0;
  font-size: ${(props) => props.theme.searchInputHeight / 3}px;
  position: relative;
  height: ${(props) => props.theme.searchInputHeight}px;
  padding-left: ${(props) => props.theme.searchInputHeight}px;
  position: relative;
  width: 100%;
  z-index: 1;
  &:focus {
    outline: none;
  }
`

const MenuInnerDiv = styled.div`
  border-top: 1px solid;
  padding: 2em 60px;
`

const MenuOuterDiv = styled.div`
  left: 0;
  background-color: ${(props) =>
    props.isFocused ? "white" : props.theme.searchInputBackgroundColor};
  border-radius: 10px;
  box-shadow: ${(props) =>
    props.isFocused &&
    "0 1px 2px 0 rgba(60, 64, 67, 0.302), 0 1px 3px 1px rgba(60, 64, 67, 0.149)"};
  overflow: hidden;
  padding-top: ${(props) => props.theme.searchInputHeight}px;
  position: absolute;
  right: 0;
  top: 0;
  transition: all ${(props) => props.theme.animationTimeNormal}s;
`

// 1

const OuterDiv = styled.div`
  position: relative;
  width: ${(props) => props.theme.searchInputWidth}px;
  ${MenuOuterDiv} {
    height: ${(props) =>
      props.isFocused ? 300 : props.theme.searchInputHeight}px;
  }
  z-index: 1;
`

export {SearchField}
